<script lang="ts">import { blurOnClick } from '../../../../js-v2/blurOnClick';
import { hoverWithDelay } from '../../../../js-v2/hoverWithDelay';
const { linkCustomCssClass = undefined, id = '', title = '', url = '#', svgIcon = undefined, enableHoverOpacity = false, openInNewTab = false, hoverWithDelayConfig = undefined, } = $props();
</script>

<a
  data-entry-id={id}
  class="Link--text {linkCustomCssClass || ''}"
  class:hover-opacity={enableHoverOpacity}
  href={url}
  target={openInNewTab ? '_blank' : undefined}
  use:blurOnClick
  use:hoverWithDelay={hoverWithDelayConfig}
>
  {#if svgIcon}
    <span class="icon">
      {@html svgIcon}
    </span>
  {/if}
  <span class="title">{title}</span>
</a>

<style>@keyframes fade-in-slide-from-top {
  from {
    opacity: 0;
    transform: translateX(0) translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateX(0) translateY(0);
  }
}
@keyframes fade-in-slide-from-left {
  from {
    opacity: 0;
    transform: translateX(-4px) translateY(0);
  }
  to {
    opacity: 1;
    transform: translateX(0) translateY(0);
  }
}
@keyframes slide-down {
  from {
    transform: translateY(-50%);
  }
  to {
    transform: translateY(0);
  }
}
/**
We use rem units for media queries to promote accessible layouts. By utilizing rem units, the computed values in media queries are determined by the user's browser-defined font size rather than our global 'font-size: 62.5%' reset. This approach ensures that our design adapts to individual user settings, enhancing accessibility. 
*/
.Link--text {
  text-decoration: none;
}
.Link--text.link-list-link {
  --letter-spacing: var(--text-variant-100-letter-spacing);
  --line-height: var(--text-variant-100-line-height);
  --font-size: var(--text-variant-100-font-size);
  --font-weight: var(--text-variant-100-font-weight);
  --font-family: var(--text-font-family);
  --max-width: var(--text-variant-100-max-width);
  color: var(--color-text);
  font-family: var(--font-family);
  font-size: var(--font-size);
  font-weight: var(--font-weight);
  letter-spacing: var(--letter-spacing);
  line-height: var(--line-height);
  max-width: var(--max-width);
  cursor: pointer;
  appearance: none;
  box-sizing: border-box;
  display: inline-block;
  vertical-align: top;
  overflow: hidden;
  position: relative;
  min-height: 0;
  max-height: none;
  margin: 0;
  padding: 2px;
  border-radius: 6px;
  border: 0;
  outline: 0;
  color: var(--color-text, var(--color-neutral-000, #000000));
  background-color: transparent;
  letter-spacing: normal;
  text-align: left;
  text-decoration: none;
  user-select: none;
  -webkit-user-drag: none;
  -webkit-tap-highlight-color: transparent;
  display: inline-flex;
  align-items: center;
  gap: 10px;
}
.Link--text.link-list-link:focus-visible:not(:active) {
  outline: var(--accessibility-focus-outline-width) var(--accessibility-focus-outline-style, solid) var(--accessibility-focus-outline-color);
  border-radius: var(--accessibility-focus-outline-border-radius);
  outline-offset: var(--accessibility-focus-outline-offset);
}
.Link--text.link-list-link .icon {
  display: inline-flex;
  align-items: center;
}
.Link--text.link-list-link .icon :global(svg *) {
  fill: var(--color-text, var(--color-neutral-000, #000000));
}
.Link--text.link-list-link .title {
  --letter-spacing: var(--text-variant-100-letter-spacing);
  --line-height: var(--text-variant-100-line-height);
  --font-size: var(--text-variant-100-font-size);
  --font-weight: var(--text-variant-100-font-weight);
  --font-family: var(--text-font-family);
  --max-width: var(--text-variant-100-max-width);
  color: var(--color-text);
  font-family: var(--font-family);
  font-size: var(--font-size);
  font-weight: var(--font-weight);
  letter-spacing: var(--letter-spacing);
  line-height: var(--line-height);
  max-width: var(--max-width);
  display: block;
  display: inline;
  padding: 3px 0px;
}
.Link--text.item-list-link {
  --letter-spacing: var(--text-variant-100-letter-spacing);
  --line-height: var(--text-variant-100-line-height);
  --font-size: var(--text-variant-100-font-size);
  --font-weight: var(--text-variant-100-font-weight);
  --font-family: var(--text-font-family);
  --max-width: var(--text-variant-100-max-width);
  color: var(--color-text);
  font-family: var(--font-family);
  font-size: var(--font-size);
  font-weight: var(--font-weight);
  letter-spacing: var(--letter-spacing);
  line-height: var(--line-height);
  max-width: var(--max-width);
  cursor: pointer;
  appearance: none;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
  display: inline-block;
  width: auto;
  height: auto;
  min-height: 0;
  max-height: none;
  min-width: 0;
  max-width: none;
  margin: 0;
  padding: 10px 10px;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: var(--color-text, var(--color-neutral-000, #000000));
  letter-spacing: normal;
  text-align: center;
  vertical-align: middle;
  text-decoration: none;
  white-space: nowrap;
  user-select: none;
  -webkit-user-drag: none;
  -webkit-tap-highlight-color: transparent;
  padding: 10px 0px;
}
.Link--text.item-list-link:focus-visible:not(:active) {
  outline: var(--accessibility-focus-outline-width) var(--accessibility-focus-outline-style, solid) var(--accessibility-focus-outline-color);
  border-radius: var(--accessibility-focus-outline-border-radius);
  outline-offset: var(--accessibility-focus-outline-offset);
}
.Link--text.item-list-link:focus {
  background: transparent;
  outline: none;
}
.Link--text.item-list-link:hover {
  background: transparent;
}
.Link--text.nav-list-link {
  --letter-spacing: var(--text-variant-100-letter-spacing);
  --line-height: var(--text-variant-100-line-height);
  --font-size: var(--text-variant-100-font-size);
  --font-weight: var(--text-variant-100-font-weight);
  --font-family: var(--text-font-family);
  --max-width: var(--text-variant-100-max-width);
  color: var(--color-text);
  font-family: var(--font-family);
  font-size: var(--font-size);
  font-weight: var(--font-weight);
  letter-spacing: var(--letter-spacing);
  line-height: var(--line-height);
  max-width: var(--max-width);
  cursor: pointer;
  appearance: none;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
  display: inline-block;
  width: auto;
  height: auto;
  min-height: 0;
  max-height: none;
  min-width: 0;
  max-width: none;
  margin: 0;
  padding: 10px 10px;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: var(--color-text, var(--color-neutral-000, #000000));
  letter-spacing: normal;
  text-align: center;
  vertical-align: middle;
  text-decoration: none;
  white-space: nowrap;
  user-select: none;
  -webkit-user-drag: none;
  -webkit-tap-highlight-color: transparent;
  padding: 18px 10px;
}
.Link--text.nav-list-link:focus-visible:not(:active) {
  outline: var(--accessibility-focus-outline-width) var(--accessibility-focus-outline-style, solid) var(--accessibility-focus-outline-color);
  border-radius: var(--accessibility-focus-outline-border-radius);
  outline-offset: var(--accessibility-focus-outline-offset);
}
.Link--text.nav-list-link:focus {
  background: transparent;
  outline: none;
}
.Link--text.nav-list-link:hover {
  background: transparent;
}
.Link--text.subcategory-large-link {
  --letter-spacing: var(--text-variant-100-letter-spacing);
  --line-height: var(--text-variant-100-line-height);
  --font-size: var(--text-variant-100-font-size);
  --font-weight: var(--text-variant-100-font-weight);
  --font-family: var(--text-font-family);
  --max-width: var(--text-variant-100-max-width);
  color: var(--color-text);
  font-family: var(--font-family);
  font-size: var(--font-size);
  font-weight: var(--font-weight);
  letter-spacing: var(--letter-spacing);
  line-height: var(--line-height);
  max-width: var(--max-width);
  cursor: pointer;
  appearance: none;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
  display: inline-block;
  width: auto;
  height: auto;
  min-height: 0;
  max-height: none;
  min-width: 0;
  max-width: none;
  margin: 0;
  padding: 10px 10px;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: var(--color-text, var(--color-neutral-000, #000000));
  letter-spacing: normal;
  text-align: center;
  vertical-align: middle;
  text-decoration: none;
  white-space: nowrap;
  user-select: none;
  -webkit-user-drag: none;
  -webkit-tap-highlight-color: transparent;
  --letter-spacing: var(--text-variant-200-letter-spacing);
  --line-height: var(--text-variant-200-line-height);
  --font-size: var(--text-variant-200-font-size);
  --font-weight: var(--text-variant-200-font-weight);
  --font-family: var(--text-font-family);
  --max-width: var(--text-variant-200-max-width);
  color: var(--color-text);
  font-family: var(--font-family);
  font-size: var(--font-size);
  font-weight: var(--font-weight);
  letter-spacing: var(--letter-spacing);
  line-height: var(--line-height);
  max-width: var(--max-width);
  padding: 5px 0px;
  display: inline-flex;
  align-items: center;
  gap: 10px;
}
.Link--text.subcategory-large-link:focus-visible:not(:active) {
  outline: var(--accessibility-focus-outline-width) var(--accessibility-focus-outline-style, solid) var(--accessibility-focus-outline-color);
  border-radius: var(--accessibility-focus-outline-border-radius);
  outline-offset: var(--accessibility-focus-outline-offset);
}
.Link--text.subcategory-large-link:focus-visible:not(:active) {
  outline: var(--accessibility-focus-outline-width) var(--accessibility-focus-outline-style, solid) var(--accessibility-focus-outline-color);
  border-radius: var(--accessibility-focus-outline-border-radius);
  outline-offset: var(--accessibility-focus-outline-offset);
}
.Link--text.subcategory-large-link:focus {
  background: transparent;
  outline: none;
}
.Link--text.subcategory-large-link:hover {
  background: transparent;
}
.Link--text.subcategory-small-link {
  --letter-spacing: var(--text-variant-100-letter-spacing);
  --line-height: var(--text-variant-100-line-height);
  --font-size: var(--text-variant-100-font-size);
  --font-weight: var(--text-variant-100-font-weight);
  --font-family: var(--text-font-family);
  --max-width: var(--text-variant-100-max-width);
  color: var(--color-text);
  font-family: var(--font-family);
  font-size: var(--font-size);
  font-weight: var(--font-weight);
  letter-spacing: var(--letter-spacing);
  line-height: var(--line-height);
  max-width: var(--max-width);
}
.Link--text.hover-opacity:hover {
  opacity: 70% !important;
}</style>
